import { gql, useMutation } from "@apollo/client";
import { useGeneralSoContext } from "src/common/context";
import { SetContractorAndInsuredPersonsInput } from "../types/types";

const ACCEPT_TERMS_AND_SET_CONTRACTOR_AND_INSURED_PERSONS_MUTATION = gql(`
mutation AcceptTermsAndSetContractorAndInsuredPersons($soId: String!, $input: SetContractorAndInsuredPersonsInput!, $offerId: String!) {
  setContractorAndInsuredPersons(id: $soId, input: $input, offerId: $offerId)
  acceptTerms(id: $offerId)
}
`);

export function useAcceptTermsAndSetContractorAndInsuredPersons() {
  const { offerId, soId } = useGeneralSoContext();
  const [mutation, info] = useMutation(ACCEPT_TERMS_AND_SET_CONTRACTOR_AND_INSURED_PERSONS_MUTATION);
  const acceptTermsAndSetContractorAndInsuredPersons = async (input: SetContractorAndInsuredPersonsInput) => {
    const { data } = await mutation({
      variables: { offerId, input, soId },
    });
    return data;
  };
  return [acceptTermsAndSetContractorAndInsuredPersons, info] as const;
}
